module.exports = __webpack_public_path__ + "static/img/2_huoma2@2x.f83b907.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/2_huoma2@2x.png
// module id = 6Ds0
// module chunks = 8